import { BROWSER } from 'esm-env';

export async function getDocument (classPK: number): Promise<BasicDocument | undefined> {
  try {
    const response = await fetch(`/api/lf/document/${classPK}.json`);
    const json = await response.json();
    if (response.ok) return json as BasicDocument;
    console.error(`Failed loading document ${classPK}`, json);
  } catch (err) {
    console.warn(err);
  }
}